


















































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      isOpen: false,
      isClosing: false,
      closeTimer: null as number | null
    };
  },
  computed: {
    chatStateClass(): string {
      if (this.isClosing) {
        return "ask-chat--closing";
      }

      if (this.isOpen) {
        return "ask-chat--open";
      }

      return "";
    }
  },
  methods: {
    toggleChat(): void {
      if (this.isOpen) {
        this.closeChat();
        return;
      }

      if (this.isClosing) {
        this.clearCloseTimer();
      }

      this.isClosing = false;
      this.isOpen = true;
    },
    closeChat(): void {
      if (!this.isOpen && !this.isClosing) {
        return;
      }

      this.isOpen = false;
      this.isClosing = true;
      this.clearCloseTimer();
      this.closeTimer = window.setTimeout(() => {
        this.isClosing = false;
        this.closeTimer = null;
      }, 280);
    },
    clearCloseTimer(): void {
      if (this.closeTimer !== null) {
        window.clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }
  },
  beforeDestroy() {
    this.clearCloseTimer();
  }
});
